import { Divider } from 'antd'

import CustomLayout from '../components/CustomLayout';
import CenteredItem from '../components/common/CenteredItem';
import DynamicGrid from '../components/common/DynamicGrid';
import StoryCard from '../components/story/StoryCard';
import NoStretchDiv from '../helpers/NoStretchDiv';
import { callApi } from '../helpers/Api';

const ProfilePage = (props) => {
    const storyCards = props.storyData.map((story, i) => {
        return (
            <StoryCard story={story} showActions={false}/>
        );
    })

    return (
        <CustomLayout 
            showFooter={false}
            showSiderExpanded={true}
            expandSiderInstantly={true}
        >
            <CenteredItem>
                <h2>Fablement's 2nd Contest</h2>
                <h3>Date:</h3>
                <p>Contest runs from September 1st, 2020 to September 30th 2020 11:59pm</p>
                <h3>Prize:</h3>
                    <p>1st: $100 gift card to amazon/equivalent</p>
                    <p>2nd/3rd: $25 gift card to amazon/equivalent</p>
                <h3>Theme:</h3>
                    <p>
                        <b>"More than meets the eye."</b>
                        <br />
                        <small>Please know this theme is a suggestion and by no means mandatory.</small>
                    </p>
                <h3>Rules:</h3>
                <ul>
                    <li>All stories must be SFW. No adult content (sexual, gore, etc)</li>
                    <li>No hateful language or visuals(hate speech, racial slurs, etc) is allowed.</li>
                    <li>Cover art is highly recommended.</li>
                    <li>You must have legal claim to all assets used.</li>
                    <li>I am trying something new with judging. Voting will be done by the number of likes a story gets on fablement. Tie-breakers will be settled by me.</li>
                </ul>
                <h3>How to submit:</h3>
                <p>Just publish your story within the month of September and it will automatically been submitted!</p>
                <h3>Any questions? Join us on &nbsp;
                    <a href="https://www.reddit.com/r/fablement/comments/ikiqvz/round_2_another_fablement_contest_is_underway/" target="_blank">
                        reddit
                    </a>
                    &nbsp;or&nbsp;
                    <a target="_blank" rel="noopener noreferrer" href="https://discord.gg/TYWryQx">discord</a> 
                    !
                </h3>
            </CenteredItem>
            <Divider className="text-darkable">Previous Winners August 2020</Divider>

            <CenteredItem>
            <h3>Fablement's first contest is now done! Thanks to all of the participants. There were some amazing submissions and I am so proud of the community. Proudly presenting the winners!</h3>

            <h2 className='center-text'>🏆 Winner! 🏆</h2>
            {storyCards[0]}
            </CenteredItem>
            <h3 className='center-text'>Runner Ups</h3>
            <NoStretchDiv style={{padding: "5%", background: "none"}}>
                <DynamicGrid 
                    gutter={16}
                    colCount={4}
                    colClassName="mobile-stretch"
                    cells={storyCards.splice(1,4)}
                />
            </NoStretchDiv>
        </CustomLayout>
    );
}

export const getStaticProps = async (ctx) => {
    var fetches = [];
    var stories = [
        'kde7ggylr6kk3',
        'kdv7b1ky6vtpt',
        'kdm4treirun4e',
        'kdv9j3kjdxepl',
        'kdf0euge7p6st',
    ]
    stories.forEach(async function (item, index) {
        fetches.push(callApi('https://fablement.com/api/story_version/home/' + item))
    })

    var storyData = [];
    await Promise.all(fetches)
    .then(values => { 
        values.forEach((value) => {
            if(value[0])
                storyData.push(value[0])
        })
    });

    return { props: {storyData}}
}

export default ProfilePage;